import {type ElementType, type ReactNode} from 'react';
import {cn} from '../lib/cn';

export type BreadcrumbType = {
  to?: string;
  hidden?: boolean;
  current?: boolean;
  icon?: ReactNode;
  asLink?: ElementType;
};

export type BreadcrumbProps = BreadcrumbType & {
  className?: string;
  children: ReactNode;
};

export function Breadcrumb({
  hidden,
  to,
  current,
  icon,
  className,
  children,
  asLink: LinkComponent = 'a',
}: BreadcrumbProps) {
  if (hidden) {
    return null;
  }

  const isLink = Boolean(to && !current);
  const contentClassName = cn(
    'flex items-center gap-2.5 text-sm font-medium text-[var(--breadcrumbs-link-color)]',
    current && 'font-bold text-[var(--breadcrumbs-current-color)]',
    isLink && 'transition-opacity hover:opacity-80',
    className,
  );

  return (
    <li className="flex gap-2.5">
      {isLink ? (
        <LinkComponent
          aria-current={current ? 'page' : undefined}
          className={contentClassName}
          {...(LinkComponent === 'a' ? {href: to} : {to, href: to})}
        >
          {icon ? <span className="shrink-0">{icon}</span> : null}
          {children}
        </LinkComponent>
      ) : (
        <div aria-current={current ? 'page' : undefined} className={contentClassName}>
          {icon ? <span className="shrink-0">{icon}</span> : null}
          {children}
        </div>
      )}
    </li>
  );
}
